angular
  .module('fg')
  .directive('fgFieldAttachDocument', [
    'fgFieldAtttachDocumentFn',
    function (fgFieldAtttachDocumentFn) {
      return {
        replace: true,
        controllerAs: 'ctrl',
        controller: [
          'fgAttachDocumentFileListService',
          '$scope',
          function (fgAttachDocumentFileListService, $scope) {
            const ctrl = this;
            ctrl.fgAttachDocumentFileListService =
              fgAttachDocumentFileListService;
            ctrl.addFile = addFile;

            function addFile(file) {
              ctrl.nodeId = ctrl.form.schema.fields[0].nodeId;

              fgAttachDocumentFileListService.addFile(
                file,
                ctrl.fieldId,
                ctrl.nodeId
              );
            }
          }
        ],
        templateUrl:
          'angular-form-gen/field-templates/default/attachdocument.ng.html',
        link: fgFieldAtttachDocumentFn
      };
    }
  ])
  .factory('fgFieldAtttachDocumentFn', [
    'pubsubService',
    'sessionService',
    'momentService',
    'fileService',
    function (pubsubService, sessionService, momentService, fileService) {
      return function ($scope, $element, $attrs, ctrls) {
        ctrls.fieldId = $attrs.fileControlId;
        ctrls.form = $scope.$parent.form;
        ctrls.user = sessionService.getUser();

        initialiseFile();

        $scope.$watch(function () {
          return ctrls.form.data && ctrls.form.data[ctrls.fieldId];
        }, initialiseFile);

        //if there is a file already uploaded against this field, add it to the list
        function initialiseFile() {
          if (ctrls.user == undefined) {
            return; // Public forms are handled by attach.document.file.list.readonly
          }
          ctrls.fgAttachDocumentFileListService.clearFiles(ctrls.fieldId);
          if (ctrls.form.schema && ctrls.form.schema.fields.length > 0) {
            let field = [];

            for (let _f = 0; _f < ctrls.form.schema.fields.length; _f++) {
              if (ctrls.form.schema.fields[_f].name == ctrls.fieldId)
                field = ctrls.form.schema.fields[_f];
            }

            const files = field.attachDocumentFileIds
              ? field.attachDocumentFileIds
              : [];

            for (let f = 0; f < files.length; f++) {
              fetchFileData(files[f]);
            }
          }
        }

        function fetchFileData(fileId) {
          fileService.getFileMetaData(fileId).then(function (fileData) {
            const file = {
              filename: fileData.filename,
              id: fileId,
              key: ctrls.fieldId,
              downloadLink: fileService.getDownloadLink(fileId),
              size: fileData.size,
              uploadedDate: momentService
                .utc(fileData.uploadedDate)
                .format('DD/MM/YYYY')
            };
            ctrls.addFile(file);
            pubsubService.publish('FILEUPLOAD_UPLOAD_COMPLETED');
          });
        }
      };
    }
  ]);
